var nurseslounge_myDashboard_degreesForMe = {
    init:function($params){
        nurseslounge_myDashboard_degreesForMe.degrees_home_search($params);
        nurseslounge_myDashboard_degreesForMe.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
        nurseslounge_myDashboard_myProfile.profile_is_complete($params, true);
        nurseslounge_myDashboard_degreesForMe.task_list_container(function($container){
            nurseslounge_myDashboard_myProfile.task_list($container, $params);
        });
        nurseslounge_myDashboard_degreesForMe.lounge_ads_location(function($config){
            nurseslounge_lounge_overview.lounge_ads_engine($config);
        });
    },
    degrees_home_search:function($params){
        var $degreesFormMeLeft = $("#nurseslounge-home-degrees-for-me .nurseslounge-home-degrees-for-me-left");
        var $degreeList = $degreesFormMeLeft.find(".degree-list:first");
        var $degreeListPreview = nurseslounge_myDashboard_degreesForMe.degree_for_me_preview();
        var $resultInfo = $degreesFormMeLeft.find(".result-info-count:first");
        var $resultPreview = '&nbsp;';
        var $paginationNav = $degreesFormMeLeft.find('.pagination-nav');
        var $paginationNavPreview = '&nbsp;';
        $resultInfo.addClass('nurseslounge-home-degrees-for-me-preload').html($resultPreview);
        $paginationNav.addClass('nurseslounge-home-degrees-for-me-preload').html($paginationNavPreview);
        $degreeList.html($degreeListPreview).promise().done(function() {
            nurseslounge_myDashboard_degreesForMe.degree_for_me_pagination($params);
        });
    },
    degree_for_me_preview:function(){
        var $chtml = '';
        for(var $i=1; $i<=10; $i++){
            $chtml+= '' +
                '<li class="shadow p-3 mb-3 bg-white rounded preview">' +
                '    <div class="row">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-4 nurseslounge-home-degrees-for-me-preload">' +
                '                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <h4 class="degree-name nurseslounge-home-degrees-for-me-preload">' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </h4>' +
                '                    <p class="degree-university nurseslounge-home-degrees-for-me-preload">&nbsp;</p>' +
                '                    <p class="text-muted degree-location nurseslounge-home-degrees-for-me-preload">&nbsp;</p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-md-auto text-center text-sm-right align-self-center">' +
                '            <div class="clg-rating">' +
                '                <div class="rating-stars mb-1">' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                </div>' +
                '                <div class="rating-count text-center text-sm-right nurseslounge-home-degrees-for-me-preload">' +
                '                &nbsp;' +
                '                </div>' +
                '            </div>' +
                '            <label class="mt-3 p-1 ads nurseslounge-home-degrees-for-me-preload">' +
                '               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '            </label>' +
                '            <button type="button" class="btn btn-save btnAnimate">View</button>' +
                '        </div>' +
                '    </div>' +
                '</li>';
        }
        return $chtml;
    },
    degree_for_me_pagination:function($params){
        var $reload;
        var $loaded = false;
        var $afterFirstPagination = false;
        var $degreesFormMeLeft = $("#nurseslounge-home-degrees-for-me .nurseslounge-home-degrees-for-me-left");
        var $degreeList = $degreesFormMeLeft.find('.degree-list');
        var $paginationNav = $degreesFormMeLeft.find('.pagination-nav');
        var $previewHeight = $degreesFormMeLeft.find('.degree-list .preview:first').innerHeight();
        var $degreeHeight = $degreeList.innerHeight();
        var $pageSize = Math.round(($degreeHeight/$previewHeight));
        var $resultInfo = $degreesFormMeLeft.find(".result-info-count:first");
        var $saveParams = $params;
        var $paginationObj;
        try{
            $paginationObj = libs.memoryGet('degree_for_me_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        $paginationObj = $paginationNav.pagination({
            pageSize: $pageSize,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource:window.location.protocol +'//'+ window.location.hostname + "/myDashboard/degreesForMe/get",
            locator: 'data.degrees',
            ajax:{
                method: "POST",
                cache:false,
                dataType: "json",
                data:$params,
                beforeSend: function() {
                    $degreeList.html(nurseslounge_myDashboard_degreesForMe.degree_for_me_preview());
                },
                complete:function($data){
                    libs.expire($data.responseJSON);
                }
            },
            totalNumberLocator: function($data) {
                return $data.data.total;
            },
            callback: function($data, $pagination) {
                $loaded = true;
                if($degreeList.length > 0 && $degreeList.offset().top > 0 && $afterFirstPagination){
                    $('html, body').animate({scrollTop:$degreeList.offset().top - 100});
                }else{
                    $afterFirstPagination = true;
                }
                var $pageNumber = $pagination.pageNumber;
                var $pageSize = $pagination.pageSize;
                var $totalNumber = $pagination.totalNumber;
                var $first = $totalNumber > 0 ? (($pageNumber-1) * $pageSize) + 1 : 0;
                var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                $paginationNav.removeClass('nurseslounge-home-degrees-for-me-preload');
                $resultInfo.removeClass('nurseslounge-home-degrees-for-me-preload').html('<strong>Showing '+$first+' - '+$last+' of '+$totalNumber+'</strong> results for <span class="link-color">Degrees</span>');
                var $chtml = nurseslounge_myDashboard_degreesForMe.degrees_for_me_item_html($data);
                libs.checkImageLoad($($chtml).find('img'), function () {
                    $degreeList.html('').html($chtml).promise().done(function () {
                        nurseslounge_myDashboard_degreesForMe.degrees_for_me_list_events($saveParams);
                    });
                });
            }
        });
        libs.memorySave('degree_for_me_pagination', $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_myDashboard_degreesForMe.degree_for_me_pagination($params);
            }else{
                clearTimeout($reload);
            }
        }, 10000);
    },
    degrees_for_me_item_html:function($loungeDegrees){
        var $userId = libs.memoryGet('user_id');
        var $chtml = '';
        $.each($loungeDegrees, function($i, $v){
            var $img = $v.lounge.logo_root_lounge;
            $chtml+='' +
                '<li class="shadow p-3 mb-3 bg-white rounded item" data-key="'+$v.key+'">';
            $chtml +='<span class="ads">';
            if($v.sponsored == 1) {
                $chtml += '<img src="/bimg/NursesLounge/pin.png">';
            }
            $chtml += '</span>';
            $chtml +=
                '     <div class="row open-degree">' +
                '         <div class="col align-self-center">' +
                '             <div class="d-flex">' +
                '                 <div class="profile-img mr-4">' +
                '                     <img src="'+$img+'?resize=80" alt="hospital" class="p-2">' +
                '                 </div>' +
                '                 <div class="list-info align-self-center w-100">' +
                '                     <h4 class="degree-name">' +
                '                         <a href="javascript:void(0)">'+$v.title+'</a>' +
                '                     </h4>' +
                '                     <p class="degree-university">'+$v.lounge.small_name+'</p>' +
                '                     <p class="text-muted degree-location">';
            if($v.lounge.location.address_city) {
                $chtml+='' +
                    $v.lounge.location.address_city + ', ';
            }
            if($v.lounge.location.address_state) {
                $chtml+='' +
                    $v.lounge.location.address_state;
            }
            $chtml+='' +
                '                     </p>' +
                '                 </div>' +
                '             </div>' +
                '         </div>' +
                '         <div class="col-md-auto text-center text-sm-right align-self-center">' +
                '             <div class="clg-rating">' +
                '                 <div class="rating-stars mb-1">' +
                nurseslounge_myDashboard_degreesForMe.add_stars($v.rating) +
                '                 </div>' +
                '                 <div class="rating-count text-center text-sm-right">' +
                $v.rating + ' / 5' +
                '                 </div>' +
                '             </div>';
            if($userId != 'guest'){
                $chtml += '<button type="button" class="btn btn-save btnAnimate open-degree">View</button>';
            }
            $chtml += '' +
                '         </div>' +
                '     </div>' +
                ' </li>';
        });
        return $chtml;
    },
    add_stars:function($rating){
        var $chtml = '';
        for(var $i=1; $i<=5; $i++) {
            var $star = $rating - $i;
            var $offsetOn;
            var $offsetOff;
            var $unique = libs.getUniqueId();
            if($star >= 0){
                $offsetOn = 100;
                $offsetOff = 0;
            }else if($star < 0 && $star > -1){
                $star = ($star * -1);
                $offsetOff = ($star * 100);
                $offsetOn = (100 - $offsetOff);
            }else{
                $offsetOn = 0;
                $offsetOff = 100;
            }
            $chtml += '' +
                '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="url(#percent'+$unique+')">' +
                '   <defs>' +
                '       <linearGradient id="percent'+$unique+'">';
            if($offsetOn > 0) {
                $chtml += '' +
                    '<stop offset="' + $offsetOn + '%" stop-color="#FDA630" stop-opacity="1"></stop>';
            }
            if($offsetOff > 0){
                $chtml += '' +
                    '<stop offset="'+$offsetOff+'%" stop-color="#E2E2E9" stop-opacity="1"></stop>';
            }
            $chtml += '' +
                '       </linearGradient>' +
                '   </defs>' +
                '   <polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566"></polygon>' +
                '</svg>';
        }
        return $chtml;
    },
    degrees_for_me_list_events:function($params){
        var $degreesFormMeLeft = $("#nurseslounge-home-degrees-for-me .nurseslounge-home-degrees-for-me-left");
        var $degreeList = $degreesFormMeLeft.find('.degree-list');
        $degreeList.find(".open-degree").unbind().click(function(){
            var $key = $(this).parents('.item:first').data('key');
            nurseslounge_lounge_degrees.add_map_show_spu($key);
        });
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-home-degrees-for-me .nurseslounge-home-degrees-for-me-right .banners")
        });
    },
    lounge_ads_location:function(cback){
        cback({
            'ads':$("#nurseslounge-home-degrees-for-me .nurseslounge-home-degrees-for-me-right .lounge-ads")
        });
    },
    //Task List Container
    task_list_container:function(cback){
        var $container = $("#nurseslounge-home-degrees-for-me .nurseslounge-home-degrees-for-me-right");
        cback($container);
    },
};
